import { StyleSheet } from 'react-native'
import { BRACKET_BOX_W } from './knockoutBracket.constants'

export const getBracketRoundColumnStyles = () =>
  StyleSheet.create({
    column: {
      width: BRACKET_BOX_W,
      justifyContent: 'center',
    },
    slot: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  })
